import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from "react";
import ConfirmAlertModal from "../../Modals/confirmAlertModal";
import GolbalSearch from "../../utility/common/helpers/GolbalSearch";
import { handleExport1 } from "../../utility/data/export/GlobalExport";
import { Row, Col, Container } from "react-bootstrap";
import Export from "../../../icons/Export.svg";
import GlobalColumnDefinations, { getHeader_FieldName } from "../../utility/grid/definitions/AgGridDefination";
import GridMaster from "../../utility/grid/GridMaster";
import { getCompletedTraining } from "../../../Services/training-service";
import { getTrainingRecordbyID } from "../../../Services/trainingRequisition-service";
import UnifiedActionRenderer from "../../utility/grid/renderers/ActionRenderers/UnifiedActionRenderer";
import Toaster, { showSuccess, showWarning } from "../../utility/ui/notifications/Toaster";
import { DeleteTrainingRecord, updateTrainingRecord } from "../../../Services/trainingRecord-service";
import AddEditAttendanceDetails from "./AddEditAttendanceDetails";
import { GridLoader } from "react-spinners";
import { ImageUploadRenderer } from "../../utility/grid/renderers/ActionRenderers/ImageUploadRenderer";
import { getPresignedURLForTrainingRecord } from "../../../Services/Welder-services";
import axios from "axios";

const TrainingFileUploadRenderer = ({
  data,
  fileInputRef,
  setRowData,
  setLoading,
  setCombinedArray,
  Imgloading,
}) => {
  const [, setImageObjectURL] = useState("");
  const [, setPreUrl] = useState([]);
  const [imageData] = useState([]);
  const [progress, setProgress] = useState(0);
  const [deleteCounter, setDeleteCounter] = useState(0);
  const [downloadloading, setdownloadLoading] = useState(false);

  // Available to add(...) by assignment inside handleFile (no redeclaration inside)
  let subjectMonth;
  let salaryCode;

  const handleFile = async (file, row, data) => {
    setLoading(true);

    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      showWarning("File size exceeds the allowed limit. Up to 5MB is allowed");
      // Reset file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      setLoading(false);
      return;
    }

    // Validate extension is .pdf (case-insensitive)
    const ext = file.name.split(".").pop()?.toLowerCase();
    if (ext !== "pdf") {
      showWarning("Please upload a PDF file. Only .pdf extension is allowed.");
      // Reset file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      setLoading(false);
      return;
    }

    // Build subjectMonth (alphanumeric only) and salaryCode
    const subject = (row.wld_trainingSub || "Training").replace(/[^a-zA-Z0-9]/g, "");
    const month = (row.wld_toDate || "").replace(/[^a-zA-Z0-9]/g, "");
    subjectMonth = `${subject}${month}`;
    salaryCode = row.wld_TrainingReqSalaryEmployeeCode;

    // Use original filename (no renaming)
    const originalFile = file;

    const objectURL = URL.createObjectURL(originalFile);
    setImageObjectURL(objectURL);
    setRowData(row);

    // Check if file already exists before setting new values
    const hasExistingFile = row.wld_trainingDocument && row.wld_trainingDocument !== "";

    // Store ONLY the filenames on the row
    row.wld_trainingDocument = originalFile.name;
    row.wld_trainingDocumentOriginal = originalFile.name;
    if (!hasExistingFile) {
      await add(row, originalFile, null);

      // Build payload to persist (store only filenames)
      const uploadData = {
        ...row,
        wld_trainingDocument: row.wld_trainingDocument,
        wld_trainingDocumentOriginal: row.wld_trainingDocumentOriginal,

      };

      // Persist via API (post-upload)
      const apiResp = await updateTrainingRecord(uploadData);
      console.log("apiResp", apiResp)
      if (!apiResp?.status) {
        showWarning(apiResp?.message || "Saving training document failed.");
        setLoading(false);
        return;
      }

      // Update UI list with new filenames
      setCombinedArray((prev) =>
        prev.map((record) =>
          record.SK === row.SK
            ? {
              ...record,
              wld_trainingDocument: row.wld_trainingDocument,
              wld_trainingDocumentOriginal: row.wld_trainingDocumentOriginal,
            }
            : record
        )
      );

      setProgress(0);
      setLoading(false);
      showSuccess("File upload completed!");
    } else {
      setLoading(false);
    }
  };

  const handleDownload = async (row, data) => {
    try {
      // Recompute subjectMonth & salaryCode from the row (generate fresh signed URL)
      const subject = (row.wld_trainingSub || "Training").replace(/[^a-zA-Z0-9]/g, "");
      const month = (row.wld_toDate || "").replace(/[^a-zA-Z0-9]/g, "");
      subjectMonth = `${subject}${month}`;
      salaryCode = row.wld_TrainingReqSalaryEmployeeCode;

      const filename = row.wld_trainingDocument; // stored only filename

      const result = await getPresignedURLForTrainingRecord(subjectMonth, salaryCode, filename);
      if (!result || !result.url) {
        console.error("Invalid presigned URL response:", result);
        showWarning("Failed to get download URL.");
        return;
      }
      const geturl = result.url;

      setdownloadLoading(true);
      try {
        const response = await fetch(geturl);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.target = "_blank";
        anchor.download = row.wld_trainingDocumentOriginal;

        anchor.click();
        window.URL.revokeObjectURL(url);

        setdownloadLoading(false);
      } catch (error) {
        console.error("Download error:", error);
        showWarning("Download failed. Please try again.");
        setdownloadLoading(false);
      }
    } catch (error) {
      console.error("Error getting download URL:", error);
      showWarning("Download failed.");
    }
  };

  const handleDeleteFile = async (row, abc, res) => {
    setLoading(true);
    row.wld_trainingDocument = "";
    row.wld_trainingDocumentOriginal = "";
    row.wld_trainingDocumentUrl = "";

    // Update database
    const result = await updateTrainingRecord(row);
    console.log("result", result)
    if (result?.status) {
      // Update UI list
      setCombinedArray((prevResult) =>
        prevResult.map((record) =>
          record.SK === row.SK
            ? {
              ...record,
              wld_trainingDocument: "",
              wld_trainingDocumentOriginal: "",
              wld_trainingDocumentUrl: "",
            }
            : record
        )
      );

      setDeleteCounter(deleteCounter + 1);
      showSuccess("File deleted successfully.");
    }
    setLoading(false);
  };

  const add = async (row, file, res) => {
    try {
      // Get a single presigned URL for the whole object
      const result = await getPresignedURLForTrainingRecord(subjectMonth, salaryCode, file.name);
      if (!result || !result.url) {
        console.error("Invalid presigned URL response:", result);
        showWarning("Failed to get upload URL. File upload failed.");
        return;
      }

      setPreUrl(result);
      row.wld_trainingDocumentUrl = result.url; // local use only (you’re not persisting this)

      await axios.put(result.url, file, {
        headers: {
          "Content-Type": "application/pdf",
        },
        onUploadProgress: (progressEvent) => {
          console.log("progressEvent", progressEvent, progressEvent.loaded / file.size)
          const completed = Math.min(
            100,
            Math.round((progressEvent.loaded / file.size) * 100)
          );
          setProgress(completed);
        },
      });
    } catch (error) {
      console.error("Error uploading file:", error);
      showWarning("File upload failed.");
      return;
    }
  };

  return (
    <ImageUploadRenderer
      Imgloading={Imgloading}
      downloadloading={downloadloading}
      setdownloadLoading={setdownloadLoading}
      key={`upload-${data.SK}-${deleteCounter}`}
      imageData={imageData}
      progress={progress}
      PreviewUrl={data.wld_trainingDocumentUrl || ""}
      profileOg={data.wld_trainingDocumentOriginal || ""}
      id={`fileUpload_${data.SK}`}
      name="fileInput"
      type="file"
      accept="application/pdf"
      ref={fileInputRef}
      selectedData={{ data }}
      handleFile={(e, params) => handleFile(e.target.files[0], params.data, imageData)}
      handleDownload={(params) => handleDownload(params.data, imageData)}
      handleDelete={(params) => handleDeleteFile(params.data, imageData)}
      size={5}
    />
  );
};



const TrainingRecord = forwardRef((props, ref) => {
  let formName = "Training";
  const [rowData, setRowData] = useState({});
  const [filteredResult, setFilteredResult] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [combinedArray, setCombinedArray] = useState([]);
  const [training] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [action, setAction] = useState("");
  const [data, setdata] = useState("");
  const [reload, setReload] = useState(false);
  const [show1, setShow1] = useState(false);
  const [, setExcelData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [Imgloading] = useState(true);
  const fileInputRef = useRef(null);
  const childRef = useRef();
  const folderTraining = "Training_Records";

  const tmpcolumnDefs = [
    {
      headerName: "Training subject",
      field: "wld_trainingSub",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Trainee Name",
      field: "wld_TrainingReqEmployeeName",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Salcode",
      field: "wld_TrainingReqSalaryEmployeeCode",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Month of Training",
      field: "wld_trainingMonth",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "From Date",
      field: "wld_fromDate",
      type: "Date",
      isCheckbox: false,
      cellRenderer: "dateCellRenderer",
      filterParams: "filterDate",
    },
    {
      headerName: "To Date",
      field: "wld_toDate",
      type: "Date",
      isCheckbox: false,
      cellRenderer: "dateCellRenderer",
      filterParams: "filterDate",
    },
    {
      headerName: "Faculty",
      field: "wld_faculty",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "AvatarCellRenderer",
    },
    {
      headerName: "Requester Department",
      field: "wld_TrainingReqRequesterDepartment",
      type: "text",
      isCheckbox: false,
      cellRenderer: ""
    },
    {
      headerName: "Attendance",
      field: "wld_attendance",
      type: "text",
      isCheckbox: false,
    },
    {
      headerName: "Score",
      field: "wld_score",
      type: "Text",
      isCheckbox: false,
    },
    {
      headerName: "Total Marks",
      field: "wld_marks",
      type: "Text",
      isCheckbox: false,

    },
    {
      headerName: "Percentage",
      field: "wld_percentage",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },

  ];

  const handleView = (row) => {
    setAction("View");
    setRowData(row);
    setShowForm(true);
  }

  const headerName = (field) => {
    let name = getHeader_FieldName(field, tmpcolumnDefs, "getHeader");
    return name;
  };

  const fieldName = (header) => {
    let name = getHeader_FieldName(header, tmpcolumnDefs, "getField");
    return name;
  };

  const fetchTraining = async () => {
    try {
      const result = await getCompletedTraining();
      if (!result || !Array.isArray(result)) {
        console.warn('No training data received');
        setFilteredResult([]);
        setCombinedArray([]);
        return;
      }

      setFilteredResult(result);
      const detailResults = await Promise.all(
        result.map(async (item) => {
          try {
            return await getTrainingRecordbyID(
              item.SK,
              item.wld_trainingSub,
              item.wld_fromDate,
              item.wld_toDate,
              item.wld_trainingMonth,
              item.wld_faculty
            );
          } catch (error) {
            console.error(`Error fetching record for ${item.SK}:`, error);
            return [];
          }
        })
      );

      const validResults = detailResults.filter((record) => Array.isArray(record) && record.length > 0);
      const nestedarray = validResults.flat();
      setCombinedArray(nestedarray);
    } catch (error) {
      console.error("Error fetching training data:", error);
      setFilteredResult([]);
      setCombinedArray([]);
    } finally {
      setLoading(false);
    }
  };

  const fileUploadRenderer = (params) => (
    <TrainingFileUploadRenderer
      data={params.data}
      fileInputRef={fileInputRef}
      setRowData={setRowData}
      folderTraining={folderTraining}
      setLoading={setLoading}
      setCombinedArray={setCombinedArray}
      Imgloading={Imgloading}
    />
  );

  const fetchColumnDefns = async () => {
    const result = GlobalColumnDefinations(tmpcolumnDefs);
    // Remove the Training Document column from tmpcolumnDefs and add it as file upload renderer
    const filteredResult = result.filter(col => col.field !== "wld_trainingDocumentOriginal");
    filteredResult.push({
      headerName: "Training Document",
      field: "wld_trainingDocumentOriginal",
      cellRenderer: fileUploadRenderer,
      minWidth: 300,
      suppressMenu: true,
    });
    filteredResult.push({ headerName: "", cellRenderer: actionRenderer, width: 300, suppressMenu: true, });
    setColumnDefs(filteredResult);
  };

  useEffect(() => {
    fetchTraining();
    fetchColumnDefns();
  }, [reload]);

  useImperativeHandle(ref, () => ({
    handleAdd: async () => {
      setAction("Add");
      setShowForm(true);
      setReload(true);
    },
  }));

  const actionRenderer = (params) => {
    return (
      <UnifiedActionRenderer
        actions={['edit', 'delete']}
        selectedData={params}
        handleEditEvent={(params) => handleEdit(params.data)}
        handleDeleteEvent={(params) => {
          setdata(params.data);
          setShow1(true);
          setAction("Delete");
        }}
      />
    );
  };

  const handleEdit = (row) => {
    setAction("Edit");
    setRowData(row);
    setShowForm(true);
  };
  const resetForm = () => {
    document.filterForm.reset();
    setFilteredResult(training);
  };



  const handleDelete = async () => {
    try {
      const result = await DeleteTrainingRecord(data);
      if (result?.data?.message === "Success") {
        setShowForm(false);
        showSuccess('Selected Training has been deleted successfully');
        setReload(!reload);
      } else {
        showWarning('Failed to delete training record');
      }
    } catch (error) {
      console.error('Error deleting training record:', error);
      showWarning('Failed to delete training record');
    } finally {
      setdata("");
      setShow1(false);
    }
  };

  const handleClose = () => {
    setShow1(false);
  };

  const handleGlobalSearch = (text) => {
    childRef.current?.setSearch(text);
  };

  const handleGlobalExport = () => {
    let filename = "TrainingMaster";
    setExcelData(filteredResult)
    console.log("combinedArray", combinedArray, tmpcolumnDefs);
    handleExport1(combinedArray, filename, columnDefs);
  };

  return (
    <>
      {loading && (
        <div className="loader-overlay">
          <GridLoader size={10} className="pageloader" />
        </div>
      )}
      <Container fluid>
        <ConfirmAlertModal
          action={action}
          handleYes={action === "Delete" ? handleDelete : handleView}
          formName={formName}
          show={show1}
          handleClose={handleClose}
        />
        <>
          <Row className="RowHeight">
            <Col md={2} sm={12} xs={12} className="ListTitle">
              Training Record list
            </Col>
            <Col>
              <div className="global-search-container">
                <GolbalSearch
                  searchplaceholdertext={
                    "Search for Training subject, Faculty"
                  }
                  filterFunc={handleGlobalSearch}
                />
                <img
                  className="allexport"
                  src={Export}
                  alt="Export"
                  onClick={handleGlobalExport}
                />
              </div>
            </Col>
          </Row>
          <GridMaster
            rowDetails={combinedArray}
            colDetails={columnDefs}
            fieldNames={fieldName}
            headerNames={headerName}
            setExcelData={setExcelData}
            ref={childRef}
          />
        </>
        {showForm && (
          <AddEditAttendanceDetails
            show={showForm}
            action={action}
            rowdata={rowData}
            onHide={() => setShowForm(false)}
            resetForm={resetForm}
            setReload={setReload}
            reload={reload}

            backdrop="static"
          />
        )}




        <Toaster />

      </Container>
    </>
  );
});

export default TrainingRecord;
